import GatewayConfig from 'app/src/data/models/GatewayConfig';
import CCTerminal from 'app/src/data/models/CCTerminal';
import CayanGeniusTerminal from 'app/src/payments/terminals/CayanGeniusTerminal';
import LightspeedPaymentsTerminal from 'app/src/payments/terminals/LightspeedPaymentsTerminal';
import VantivBlacklineTerminal from 'app/src/payments/terminals/VantivBlacklineTerminal';
import VantivTriPOSTerminal from 'app/src/payments/terminals/VantivTriPOSTerminal';
import StripeTerminal from 'app/src/payments/terminals/StripeTerminal';
import TyroTerminal from 'app/src/payments/terminals/TyroTerminal';

/**
 * Definition of the TerminalFactory class.  It provides an interface to construct
 * concrete terminal implementations.
 */
export default class TerminalFactory {
  /**
   * Factory method to generate a terminal of the appropriate type
   *
   * @param gatewayType {GatewayConfig.GatewayType}   The type of gateway
   * @param terminalModel {CCTerminal} A model for the terminal
   *
   * @return {*}  A terminal of the appropriate type
   */
  static createTerminal(gatewayType, terminalModel) {
    let terminal = null;

    if (gatewayType && terminalModel) {
      switch (gatewayType) {
        case GatewayConfig.GatewayType.CAYAN:
          if (terminalModel.get('type') === CCTerminal.TerminalType.GENIUS) {
            terminal = new CayanGeniusTerminal(terminalModel);
          }
          break;

        case GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS:
          if (
            [
              CCTerminal.TerminalType.LIGHTSPEED,
              CCTerminal.TerminalType.LIGHTSPEED_E285_ADYEN,
              CCTerminal.TerminalType.LIGHTSPEED_M400_ADYEN,
              CCTerminal.TerminalType.LIGHTSPEED_P400_PLUS_ADYEN,
              CCTerminal.TerminalType.LIGHTSPEED_V400M_ADYEN,
            ].includes(terminalModel.get('type'))
          ) {
            terminal = new LightspeedPaymentsTerminal(terminalModel);
          }

          if (
            [
              CCTerminal.TerminalType.LIGHTSPEED_P400_PLUS_STRIPE,
              CCTerminal.TerminalType.LIGHTSPEED_BBPOS_WISEPOSE_STRIPE,
            ].includes(terminalModel.get('type'))
          ) {
            terminal = new StripeTerminal(terminalModel);
          }
          break;

        case GatewayConfig.GatewayType.FIRST_DATA:
        case GatewayConfig.GatewayType.VANTIV_CANADA:
        case GatewayConfig.GatewayType.VANTIV_US:
          if (terminalModel.get('type') === CCTerminal.TerminalType.BLACKLINE) {
            terminal = new VantivBlacklineTerminal(terminalModel);
          }

          break;

        case GatewayConfig.GatewayType.VANTIV_TRIPOS:
          if (terminalModel.get('type') === CCTerminal.TerminalType.TRIPOS) {
            terminal = new VantivTriPOSTerminal(terminalModel);
          }
          break;

        case GatewayConfig.GatewayType.TYRO:
          if (
            terminalModel.get('type') === CCTerminal.TerminalType.YOXIMO ||
            terminalModel.get('type') === CCTerminal.TerminalType.YOMANI
          ) {
            terminal = new TyroTerminal(terminalModel);
          }
          break;

        default:
          break;
      }
    }

    return terminal;
  }
}
